export default __webpack_public_path__ + "static/media/roof.acc2bfd8.svg";